// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Maintenance event that can be displayed to users
 */
export interface MaintenanceEventApiInput {
  startTime: string;
  endTime: string;
  message: string;
  createdAt: string;
  createdBy: string;
}
